export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appPageTransition = false

export const appLayoutTransition = false

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#fbcfe8"},{"name":"description","content":"mulberry’ss — шовкові наволочки, аксесуари та одяг. Зроблено в Україні."},{"property":"og:site_name","content":"mulberry’ss"},{"property":"og:type","content":"website"},{"property":"og:title","content":"mulberry’ss — інтернет-магазин"},{"property":"og:description","content":"Шовкові наволочки, аксесуари та одяг."},{"property":"og:image","content":"https://mulberryss.shop/og-default.jpg?v=1"},{"property":"og:image:secure_url","content":"https://mulberryss.shop/og-default.jpg?v=1"},{"property":"og:image:type","content":"image/jpeg"},{"property":"og:image:width","content":"1300"},{"property":"og:image:height","content":"867"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"mulberry’ss — інтернет-магазин"},{"name":"twitter:description","content":"Шовкові наволочки, аксесуари та одяг."},{"name":"twitter:image","content":"https://mulberryss.shop/og-default.jpg?v=1"},{"property":"og:locale","content":"uk_UA"}],"link":[{"rel":"icon","href":"/favicon.png"},{"rel":"preconnect","href":"https://firestore.googleapis.com","crossorigin":""}],"style":[],"script":[],"noscript":[],"title":"mulberry’ss — інтернет-магазин","htmlAttrs":{"lang":"uk"},"titleTemplate":"%s — mulberry'ss"}

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true